module.exports = __webpack_public_path__ + "img/16d001-02.b8f0dd61.jpg";